import { ComponentType } from 'react';
import { IndicatorsContainerProps } from 'react-select';
import { CommonSelectProps, SelectOption } from '../../types';
import { FormErrorIcon, FormWarningIcon } from '@ardoq/forms';
import { IconSize } from '@ardoq/icons';

export const IndicatorsContainer: ComponentType<
  IndicatorsContainerProps<SelectOption<unknown>>
> = ({ children, selectProps }) => {
  const { hasError, errorMessage, hasWarning, warningMessage } =
    selectProps as CommonSelectProps;
  const showErrorIcon = hasError || Boolean(errorMessage);
  const showWarningIcon =
    !showErrorIcon && (hasWarning || Boolean(warningMessage));
  return (
    <>
      {showErrorIcon && <FormErrorIcon iconSize={IconSize.MEDIUM} />}
      {showWarningIcon && <FormWarningIcon iconSize={IconSize.MEDIUM} />}
      {children}
    </>
  );
};
